<template>
  <div class="mall-payment">
    <div class="payTmContent">
        <div class="payment-price" v-if="paymentStatus">
            <p class="info-text">आपका पेमेंट डिले हो रहा है , चिंता ना करें ।<br /> 100% Mall91 पेमेंट गारंटी है ।</p>
            <img
            src="../../../assets/images/icons/mall-loading.svg"
            class="payTmIcon"
            alt="waiting-icon"
            />
            <span class="loading">Loading ...</span>
            <div>
              <span class="waiting"
                >Your Payment Processing
                <strong>Rs. 0</strong></span
              >
              <span class="paytm"
                >Mall91 Payment Processing
                <strong>Rs.1236</strong></span
              >
            </div>
            <p class='restrict'>Do not press back button while payment processing</p>
        </div>
      <div class="payment-price" v-if="polling.requestStatus ==='RETRY'">
        <p class="info-text">Your Transaction is Processing</p>
        <img
          src="../../../assets/images/icons/mall-loading.svg"
          class="payTmIcon"
          alt="waiting-icon"
        />
        <span class="loading">Loading ...</span>
        <div>
          <span class="waiting"
            >Your Payment Processing
            <strong>Rs. 0</strong></span
          >
          <span class="paytm"
            >Mall91 Payment Processing
            <strong>Rs. 156</strong></span
          >
        </div>
        <p class='restrict'>Do not press back button while payment processing</p>
      </div>
      <div class="payment-price" v-if="polling.requestStatus ==='SUCCESS'">
        <p class="info-text" style="color:green">Your Transaction has been Processed</p>
        <img
          src="../../../assets/images/icons/check-mark-success.gif"
          class="payTmIcon"
          alt="waiting-icon"
        />
        <span class="loading" style="color: #0063D3;font-weight:600" @click="goToOrders()">Go to My Orders</span>
        
      </div>
      <div class="payment-price" v-if="polling.requestStatus ==='FAIL'">
        <p class="info-text"  style="color:red">{{polling.appMessage}}</p> 
        <img
          src="../../../assets/images/icons/payment-failed.svg"
          class="payTmIcon"
          alt="waiting-icon"
        /> 
        <span class="loading" style="color: #0063D3;font-weight:600" @click="goToOrders()">Go to My Orders</span>    
      </div>
      <div class="payment-price" v-if="isExceptionError">
        <p class="info-text"  style="color:red">Something went wrong</p> 
        <img
          src="../../../assets/images/icons/payment-failed.svg"
          class="payTmIcon"
          alt="waiting-icon"
        /> 
        <span class="loading" style="color: #0063D3;font-weight:600" @click="goToOrders()">Go to My Orders</span>    
      </div>
    </div>
  </div>
</template>

<script>
import ApiCaller from "../../../utils/apicaller";
import constant from "../../../utils/constant";
export default {
  name: "Mall91PaymentWait",
  data() {
    return {
      polling: {},
      intervalId: 0,
      intervalCount: 0,
      intervalCountTime: 36,
      paymentStatus: true,
      isExceptionError: false
    };
  },
  methods: {
      goToOrders(){
      this.$store.commit("saveData", {
          localShopOrders: [],
          localShopIndex: 0,
          filterBy: 'PENDING',
          type: "localshop_orders",
        });
      this.$router.push('/order-history')
      },
    status() {
      if (this.intervalCount >= this.intervalCountTime) {
        clearInterval(this.intervalId);
      } else {
        this.intervalId = setInterval(() => {
          if (this.intervalCount >= this.intervalCountTime) {
            clearInterval(this.intervalId);
          }
          this.intervalCount++;
          ApiCaller(
            constant.LOCAL_SHOP_URL_ORDER,
            `check-order-payment-status-by-orderid/${this.$route.params.orderId}`,
            "get"
          ).then((data) => {
            this.polling = data.data;
            this.paymentStatus = false
            if (data.data.requestStatus != null) {
              if (data.data.requestStatus == "RETRY") {
              } else if (
                ["FAIL", "SUCCESS"].includes(
                  data.data.requestStatus
                )
              ) {
                clearInterval(this.intervalId);
              }
            } else {
              clearInterval(this.intervalId);
            }
          }).catch(err=>{
            this.isExceptionError = true
            this.paymentStatus = false
            clearInterval(this.intervalId);
          })
        }, 5000);
      }
    },
  },
  mounted() {
    this.status();
  },
};
</script>

<style lang="scss" scoped>
.mall-payment {
  height: 100vh;
  overflow: scroll;
  .payTmContent {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }
  .payment-price {
    background: #fff;
    position: relative;
    text-align: center;
    /* border: 1px solid #ccc; */
    border-radius: 10px;
    height: auto;
    padding: 50px 0 30px;
    margin: 20px 0 50px;
    .info-text{
        font-weight: 600;
    }
    .payTmIcon {
    //   width: 70px !important;
      height: 70px;
      border-radius: 100px;
      padding: 10px;
      margin: 25px auto 0;
    //   background: #00000073;
    //   border: 2px solid #ff880c;
    }
    span {
      display: block;
      padding-bottom: 8px;
      font-size: 0.938em;
      &.loading{
          padding-bottom: 25px;
      }
    }
  }
  .restrict{
          font-size: 0.688em;
    position: absolute;
    bottom: -100px;
    transform: translateX(-50%);
    left: 50%;
    width: 100%;
  }
}
</style>